<template>
  <div
    class="content-editable"
    :class="{ focused }"
    ref="editable"
    contenteditable
    v-on="listeners"
    @focus="focused = true"
    @blur="focused = false">
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      focused: false,
    };
  },
  computed: {
    listeners() {
      return { ...this.$listeners, input: this.onInput };
    },
  },
  mounted() {
    this.$refs.editable.innerText = this.value;
  },
  methods: {
    onInput(e) {
      this.$emit('input', e.target.innerText);
    },
  },
};
</script>

<style lang="scss">
.content-editable {
  min-height: 100px;
  padding-bottom: 1rem;
  outline: none;
  font-size: 16px;
  white-space: pre-wrap;
  font-variant-ligatures: none;

  &:before {
    border-color: rgba(0, 0, 0, 0.42);
    border-style: solid;
    border-width: thin 0 0 0;
    bottom: 0;
    content: "";
    left: 0;
    position: absolute;
    -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    width: 100%;
  }

  &.focused:before {
    border-color: rgba(0, 0, 0, 0.87);
  }

  &:after {
    border-color: #2d48c5;
    border-style: solid;
    border-width: thin 0 thin 0;
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
    bottom: 0;
    content: "";
    left: 0;
    position: absolute;
    -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    width: 100%;
  }

  &.focused:after {
    transform: scaleX(1);
  }
}
</style>
